module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Electric/Gas-stove-34e15a42c334061c4cb7bed02a8a813d.svg";